import { Injectable, Inject, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppConfig } from '../../models/appConfig.model';
import * as $ from "jquery";
import { CLPUser, UserResponse } from '../../models/clpuser.model';
import { catchError } from 'rxjs/operators';
import { SearchContactService } from '../Searchcontact.service';
import { Group, Item, keyValue, SearchItem, SearchItemListResponse, SearchQueryResponse } from '../../models/search.model';
import { UtilityService } from './utility.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactList, ContactListResponse } from '../../models/contact.model';
import { NotificationService } from '../notification.service';

import { isNullOrUndefined, isNull, isNumber } from 'util';
import { LocalService } from './local.service';
import { ContactService } from '../contact.service';
import { eCustomSearchCategory, eFeatures } from '../../models/enum.model';
import { RoleFeaturePermissions } from '../../models/roleContainer.model';
import { LeadSettingService } from '../leadSetting.service';
import { LeadListResponse } from '../../models/lead.model';
import { GlobalService } from '../global.service';

//$(document.body).click(function () {
//  $(".menu-show").removeClass("menu-show");
//});

@Injectable()
export class ContactSearchService {

  contactListChanged = new EventEmitter();
  /*lead*/
  leadListChanged = new EventEmitter();

  private baseUrl: string;
  private api: string = "api/Authentication";

  savedQueryValue: string = '0';
  isDrpSavedQueryChanged: boolean = false;
  isSearchEditClick: boolean = false;
  showSpinner: boolean = false;
  savedsearchQueryResponse: SearchQueryResponse;

  queryDataLoaded: SearchQueryResponse = <SearchQueryResponse>{};
  contactListResponse: ContactListResponse;
  public encryptedUser: string = '';
  searchQueriesForm: FormGroup;
  groups: Group[] = [];
  isFromLead: boolean = false;
  leadId: number = 0;
  isNewRowsAddedOnLoad: any;
  contactsData: ContactList[] = [];
  public initContactsData: ContactList[] = [];
  private getContactsSearchSubscription: Subscription;
  isNewRowAdded: boolean = false;
  savedQuery_Filter: keyValue[] = [];
  searchItemListResponse: SearchItemListResponse;
  searchItems: SearchItem[] = <SearchItem[]>{};
  itemData_user_all: Item[] = <Item[]>{};
  user: CLPUser;

    routeUserId: number;
    routeContactId: number;

    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    leadListResponse: LeadListResponse;

    private updateActivityList = new BehaviorSubject<boolean>(false);
    updateActivityList$ = this.updateActivityList.asObservable();

    // call this when popup closes
    updateActivity(status: boolean) {
        this.updateActivityList.next(status);
    }

  constructor(private _router: Router,
    private _route: ActivatedRoute,
    private httpClient: HttpClient,
    private _searchContactService: SearchContactService,
    private _utilityService: UtilityService,
    private notifyService: NotificationService,
      private _localService: LocalService,
      private _globalService: GlobalService,
    public _contactService: ContactService,
    private leadSettingService: LeadSettingService,
    public fb: FormBuilder,
    @Inject('BASE_URL') _baseUrl: string) {
    this.baseUrl = _baseUrl + this.api;

    if (!isNullOrUndefined(localStorage.getItem("token"))) {
      this.encryptedUser = localStorage.getItem("token");

        this.authenticateR(() => {
          if (!isNullOrUndefined(this.user)) {
            this.searchQueriesForm = this.prepareSearchQueriesForm();
            this.isFromLead ? this.getLeadSearch() : this.getContactSearch();
          }
          //else {
          //  this._router.navigate(['/unauthorized']);
          //}
        })
      }
    //else {
    //    let url: string = this._router.url;
    //    this._globalService.requestedUrl = url;
    //    this._router.navigate(['/unauthorized']);
    //  }
  
  }

  authenticateUser() {
    if (!isNullOrUndefined(localStorage.getItem("token"))) {
      this.encryptedUser = localStorage.getItem("token");

      this.authenticateR(() => {
        if (!isNullOrUndefined(this.user)) {
          this.searchQueriesForm = this.prepareSearchQueriesForm();
            this.isFromLead ? this.getLeadSearch() : this.getContactSearch();
        }
        else {
          this._router.navigate(['/unauthorized']);
        }
      })
    }
    else {
      this._router.navigate(['/login']);
    }

  }

  private async authenticateR(callback) {
    await this._localService.authenticateUser(this.encryptedUser, eFeatures.NewContact)
      .then(async (result: UserResponse) => {
        if (result) {
          this.userResponse = UtilityService.clone(result);
          if (!isNullOrUndefined(this.userResponse)) {
            this.user = this.userResponse.user;
            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
          }
        }
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this._utilityService.handleErrorResponse(err);
      });
    callback();
  }

  async getContactSearch() {
    await this._searchContactService.getSearchFields(this.encryptedUser, this.user?.cLPCompanyID)
      .then(async (result: SearchItemListResponse) => {
        if (result) {
          this.searchItemListResponse = UtilityService.clone(result);
          this.searchItems = this.searchItemListResponse.searchItems;
          this.savedQuery_Filter = this.searchItemListResponse.savedQueries;
          this.itemData_user_all = this.searchItems.filter(i => i.displayValue == "User").length > 0 ? this.searchItems.filter(i => i.displayValue == "User")[0].itemData : [];
        }
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this._utilityService.handleErrorResponse(err);
      });
  }

  async getLeadSearch() {
    await this._searchContactService.getLeadSearchFields(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID)
      .then(async (result: SearchItemListResponse) => {
        if (result) {
          this.searchItemListResponse = UtilityService.clone(result);
          this.searchItems = this.searchItemListResponse.searchItems;
          this.savedQuery_Filter = this.searchItemListResponse.savedQueries;
          this.itemData_user_all = this.searchItems.filter(i => i.displayValue == "User").length > 0 ? this.searchItems.filter(i => i.displayValue == "User")[0].itemData : [];
          }
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this._utilityService.handleErrorResponse(err);
      });
  }

  async getContacts() {
    var userId = this.user.cLPUserID;
    await this._contactService.getContacts(this.encryptedUser, userId)
      .then(async (result: ContactListResponse) => {
        if (result) {
          this.contactListResponse = UtilityService.clone(result);
          this.contactListChanged.emit(this.contactListResponse.contactList);
          this.contactsData = this.contactListResponse.contactList;
          this.initContactsData = this.contactListResponse.contactList;
          this.showSpinner = false;
        }
        else
          this.showSpinner = false;
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this.showSpinner = false;
        this._utilityService.handleErrorResponse(err);
      });
  }

  async getLeadList() {
    this.showSpinner = true;
    await this.leadSettingService.getLeadListByCompanyId(this.encryptedUser, this.user.cLPCompanyID, this.leadId)
      .then(async (result: LeadListResponse) => {
        if (result) {
          this.leadListResponse = UtilityService.clone(result);
          this.leadListChanged.emit(this.leadListResponse.leads);
          this.showSpinner = false;
        }
        this.showSpinner = false
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this.showSpinner = false;
        this._utilityService.handleErrorResponse(err);
      });
  }
/* for lead*/

  private prepareSearchQueriesForm(): FormGroup {
    this.isNewRowAdded = true;
    return new FormGroup({
      searchQueries: this.fb.array([this.fb.group({
        cLPUserID: '-1',
        searchItem: [-1, Validators.required],
        operator: ['', Validators.required],
        searchItemValue: '',
        groupBy: '',
        mainOperator: ['', Validators.required],
        action: '',
        isSelected: false,
        tableName: '',
        columnName: '',
        dtStart: '',
        dtEnd: '',
        selectedValueForMultiSelect: '',
        txtRangeFrom: '',
        txtRangeTo: ''
      })]),
    });
  }

  get searchQueriesCtls() {
    return this.searchQueriesForm.get('searchQueries') as FormArray;
  }

  drpSavedQueries_onChange(event) {
    this.isSearchEditClick = false;
    this.showSpinner = true;
      $("td[id^=tdAddGroup]").remove();
      var selectValue = $('#drpSavedQueries').val();
      this.savedQueryValue = selectValue;
      if ((selectValue != "0") && (selectValue != "-2")) {
        this.isDrpSavedQueryChanged = true;
        this._searchContactService.getSavedSearhById(this.encryptedUser, +selectValue)
        .then(res => {
          if (res) {
            this.savedsearchQueryResponse = UtilityService.clone(res);
            var _searchQueryList = this.savedsearchQueryResponse.searchQueryList;
            this.queryDataLoaded = this.savedsearchQueryResponse;
            var searchQueriesCtls_length = this.searchQueriesCtls.controls.length;
            this.searchQueriesCtls.controls = [];
            this.groups = this.savedsearchQueryResponse.group;
            for (var i = 0; i < _searchQueryList.length; i++) {
              this.searchQueriesCtls.push(this.fb.group({
                cLPUserID: '-1',
                searchItem: [-1, Validators.required],
                operator: ['', Validators.required],
                searchItemValue: '',
                groupBy: '',
                mainOperator: ['', Validators.required],
                action: '',
                isSelected: false,
                tableName: '',
                columnName: '',
                dtStart: '',
                dtEnd: '',
                selectedValueForMultiSelect: '',
                txtRangeFrom: '',
                txtRangeTo: ''
              }))
            }
            /*this.showSpinner = false;*/
            this.isNewRowsAddedOnLoad = true;
            this.isDrpSavedQueryChanged = false;
            this.isFromLead ? this.getLeadSearchBySaveQuery(this.queryDataLoaded) : this.btnRunSavedSearch_click();
          }
          else {
            this.isDrpSavedQueryChanged = false;
            this.showSpinner = false;
          }
        }).catch((err: HttpErrorResponse) => {
          this._utilityService.handleErrorResponse(err);
          this.isDrpSavedQueryChanged = false;
          this.showSpinner = false;
        });

    }
      else {
        this.isFromLead ? this.getLeadList() : this.getContacts();
      if (this.savedQueryValue == "-2")
        this.setSavedSearchDropDown();
      //TODO - Check for all savedQueryValue (Handling for -2 same as 0)
      this.showSpinner = false;
    }
  }

  async getLeadSearchBySaveQuery(queryDataLoaded) {
    this.showSpinner = true;
    await this.leadSettingService.searchSaveLead(this.encryptedUser, this.queryDataLoaded, this.user.cLPUserID)
      .then(async (result: LeadListResponse) => {
        if (result) {
          var res = UtilityService.clone(result);
          this.leadListResponse = res;
          this.leadListChanged.emit(this.leadListResponse.leads);
          this.showSpinner = false;
        }
        this.showSpinner = false
      })
      .catch((err: HttpErrorResponse) => {
        console.log(err);
        this.showSpinner = false;
        this._utilityService.handleErrorResponse(err);
      });
  }

  setSavedSearchDropDown() {
    setTimeout(() => {
      var savedValue = this.savedQueryValue;
      $("#drpSavedQueries").val(savedValue);
      $("#drpSavedQueries option[value=" + savedValue + "]");
    }, 1000);
  }

  btnRunSavedSearch_click() {
    var selectValue = $('#drpSavedQueries').val();
    if (selectValue != "0") {
      this._searchContactService.executeSavedQuery(this.encryptedUser, +selectValue)
        .then(res => {
          if (res) {
            this.contactListResponse = UtilityService.clone(res);
            this.contactListChanged.emit(this.contactListResponse.contactList);
            /*lead*/
            /*this.leadListChanged.emit([]);*/
            this.contactsData = this.contactListResponse.contactList;
            this.initContactsData = this.contactListResponse.contactList;
            this.getContactsSearchSubscription = null as Subscription;
            this.showSpinner = false;
          }
          else {
            this.showSpinner = false;
            this.notifyService.showError("Error during Fetching data. Please contact administrator!", "", 3000);
          }
        }).catch((err: HttpErrorResponse) => {
          this.showSpinner = false;
          this._utilityService.handleErrorResponse(err);
        });
    }
  }

  //Edit Search
  editSavedQuery() {
    var selectValue = $('#drpSavedQueries').val();
    if (selectValue != "0" && !isNullOrUndefined(this.savedsearchQueryResponse)) {
      this.isSearchEditClick = true;
    }
  }
  //Edit Search

}
